import React from 'react';

import { Badge } from '@/components/ui/badge';
import { indexLocations } from '@/constants/index-locations';

const ServerLocations: React.FC = () => (
  <section className="mx-auto max-w-5xl px-6 py-12 text-center sm:py-12 md:max-w-7xl">
    <div className="mb-8 font-codeSaver uppercase text-primary">
      Server locations
    </div>
    <div className="my-2.5 text-balance text-3xl font-semibold sm:text-4xl">
      We got fast servers all over the globe
    </div>
    <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
      {indexLocations.map((location) => (
        <Badge
          key={location.city}
          variant="outline"
          className="rounded-full px-4 py-2 text-xs sm:text-sm"
        >
          <div className="mr-2 h-3.5 w-3.5 overflow-hidden rounded-full">
            <img
              src={`/images/flags/rounded16x16/${location.flag}.png`}
              alt="flag"
            />
          </div>
          <div className="font-medium">{location.city}</div>
          <div className="ml-auto animate-pulse rounded-full border border-[#0BAEEA66] p-1">
            <div className="h-1 w-1 rounded-full bg-primary"></div>
          </div>
        </Badge>
      ))}
    </div>
  </section>
);

export default ServerLocations;
